import React, {FC, useEffect, useState} from 'react';
import GatewayService from "../../service/GatewayService";
import {Feed} from "../../models/Feed";
import {Exchange} from "../../models/Exchange";
import AppConstants from "../../util/AppConstants";
// @ts-ignore
// import faker from 'faker';


const Component : FC<Exchange> = (feed: Exchange) => {
    return <tr>
        <td>{feed.from}</td>
        <td>{feed.to}</td>
        <td>{feed.buyPrice}</td>
        <td>{feed.sellPrice}</td>
        <td>{feed.qty}</td>
        <td>{feed.couponDiff}</td>
        <td>{feed.monthsDiff}</td>
        <td>{feed.expectedProfit}</td>
    </tr>
}

const ExchangeComponent:FC = () => {
    const [data, setData] = useState<Array<Exchange>>([])
    const [interest, setInterest] = useState(19)
    const [refresh, setRefresh] = useState(true)
    const sorter = (sortBy: string) => {
        const isAsc = AppConstants.sorterMap.get(sortBy) || false
        // @ts-ignore
        defaultSorter = (a, b)=>isAsc?a[sortBy]-b[sortBy] : b[sortBy] - a[sortBy]
        AppConstants.sorterMap.set(sortBy, !isAsc)
        setRefresh(!refresh)
    }
    useEffect(()=>{
        feed()
    },[])
    function feed() {
        GatewayService.getAllExchanges(interest).then(setData).catch(console.error)
    }

    return<>
        <input type="text" value={interest} onChange={event => setInterest(parseFloat(event.target.value))}/>
        <button onClick={()=>feed()}>refresh</button>
        <table className={"full"}>
            <thead>
            <tr>
                <th onClick={()=> sorter("from")}>from</th>
                <th onClick={()=> sorter("to")} >to</th>
                <th onClick={()=> sorter("buyPrice")}>buyPrice</th>
                <th onClick={()=> sorter("sellPrice")}>sellPrice</th>
                <th onClick={()=> sorter("qty")}>qty</th>
                <th onClick={()=> sorter("couponDiff")}>couponDiff</th>
                <th onClick={()=> sorter("monthsDiff")}>monthsDiff</th>
                <th onClick={()=> sorter("expectedProfit")}>expectedProfit</th>
            </tr>
            </thead>
            <tbody>
            {data.map(feed => <Component
                // key = {feed.sgb.tradingsymbol}
                {...feed}/>)}
            </tbody>
        </table>    </>
}

export default ExchangeComponent